import { InputNumber } from 'antd';

const InputLp = ({ value, logo, symbol }: { value: string, logo: string, symbol: string }) => {
    return (
        <div className="p-2.5 bg-white rounded-5  border border-ee text-mainBlack">
            <div className="text-a8 text-sm">输入</div>

            <div className='flex items-center justify-between'>
                <InputNumber
                    value={value || ''}
                    controls={false}
                    stringMode
                    readOnly
                    className="w-full text-6.5 font-medium mr-2 "
                    size="large"
                />
                <div
                    className="box-border px-2.5 py-1.5 flex items-center border rounded-5 border-e2 cursor-pointer"
                >
                    <img className='w-6 min-w-6 mr-2' src={logo} alt="" />
                    <span className="text-1d text-sm mr-2.5">{symbol}</span>
                </div>
            </div>
        </div>
    )
}

export default InputLp